import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Providers from "./components/providers";
import themeConfigArr from "./themeConfig";
import { useAppDispatch, useAppSelector } from "./redux/redux-hooks";
import { useEffect } from "react";
import { getDomainArtifacts, setIsArtifactsLoading } from "./redux/reducers/appSlice";

interface ApplyThemeProps {
  themeColor: string;
  removeLoader: () => void;
}

const applyTheme = ({ themeColor, removeLoader }: ApplyThemeProps) => {
  const head = document.getElementsByTagName("head");

  const themeConfig = themeConfigArr.find((t) => t.name === themeColor);
  if (head?.[0] && themeColor && themeConfig) {
    let strVars = "";
    Object.entries(themeConfig.vars).forEach(([key, value]) => {
      strVars += `${key}: ${value};`;
    });
    // html[0].style = strVars;
    if (strVars && strVars.trim().length > 0) {
      head[0].appendChild(document.createElement("style")).textContent = `:root { ${strVars} }`;
      removeLoader();
    } else {
      removeLoader();
    }
  } else {
    removeLoader();
  }
};

const ApplyAppTheme = () => {
  const dispatch = useAppDispatch();
  const { artifacts } = useAppSelector((state) => state.app);

  useEffect(() => {
    dispatch(getDomainArtifacts());
  }, []);

  const removeLoader = () => {
    const timeoutId = setTimeout(() => {
      dispatch(setIsArtifactsLoading(false));
    }, 500);

    return () => clearTimeout(timeoutId);
  };

  useEffect(() => {
    const themeColor = artifacts?.theme_color;

    if (themeColor) applyTheme({ themeColor, removeLoader });
    else dispatch(setIsArtifactsLoading(false));
  }, [artifacts?.theme_color]);

  return null;
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Providers>
    <ApplyAppTheme />
    <App />
  </Providers>
);
